import { ReactNode, useContext } from 'react';
import { useSelector } from 'react-redux';
import WorkflowConstructor from './index';
import { ModalsKeys, TabsOption } from '../../global';
import { ModalsContainer } from 'components/shared/Modals';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { InternalTiersContainer } from './InternalTiers/InternalTiersContainer';
import { FinanceProgramModal, PreviewFinanceProgramModal } from 'modules/financeProgram';
import { portalConfigurationsSelectors } from '../../redux/portalConfigurationReducer';
import { CommonDataContext } from 'contexts/CommonDataContext';
import { ScorecardBuilderContainer } from './ScorecardBuilder';

const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.FinanceForm]: <FinanceProgramModal />,
  [ModalsKeys.PreviewFinanceForm]: <PreviewFinanceProgramModal />,
};

export const PrescreenModuleContainer = () => {
  const { isLenderUser } = useContext(CommonDataContext);

  const account = useSelector((state: any) => state.account);
  const lp = useSelector((state: any) => state.lp);
  const disabledLenderProfiles = useSelector((state: any) => state.disabledLenderProfiles);

  // Waterfall active (currently) determines if the waterfall that is saved to the DB is run or not on credit app receipt.
  // The only way this is false is if "Prescreen Management -> Module Type" is set to "Off" in the PCW
  const type = useSelector(portalConfigurationsSelectors.prescreenModuleType);
  const moduleName = useSelector(portalConfigurationsSelectors.prescreenModuleName);
  const isTiersBuilderHidden = useSelector(portalConfigurationsSelectors.isTiersBuilderHidden);
  const isPrescreenScorecardBuilderHidden = useSelector(
    portalConfigurationsSelectors.isPrescreenScorecardBuilderHidden
  );

  const tabs: TabsOption[] = [
    {
      label: 'Prescreen Tools',
      value: 'lenderWaterfall',
      component: (
        <WorkflowConstructor
          lp={lp}
          disabledLenderProfiles={disabledLenderProfiles}
          type={type}
          account={account}
          moduleName={moduleName}
          waterfallActive={true}
        />
      ),
    },
    {
      value: 'tiers',
      label: 'Internal Tiers',
      isVisible: !isTiersBuilderHidden && isPrescreenScorecardBuilderHidden, // isTiersBuilderHidden setting is available only for dealers (from portal setup), but lenders need to hide it if Scorecard builder visible
      component: <InternalTiersContainer accountId={account.id} />,
    },
    {
      value: 'scorecardBuilder',
      label: 'Scorecard builder',
      isVisible: !isPrescreenScorecardBuilderHidden,
      component: <ScorecardBuilderContainer accountId={account.id} />,
    },
  ];

  return (
    <>
      <TabsContainer tabs={tabs} />
      <ModalsContainer modalsWithKeys={modalsWithKeys} />
    </>
  );
};
